import { setSsoSession } from "../hooks/useSsoSession";

// Mirrors the backend's _INTERNAL_EMAIL_SUFFIXES (utilities/auth_decorators.py).
// The backend is the real gate (validate_admin_user); this only fails fast with a
// friendly message.
const INTERNAL_EMAIL_SUFFIXES = ["@coverflow.com", "@coverflow.tech"];

export const INTERNAL_ONLY_MESSAGE =
  "Access restricted. Only @coverflow.com accounts are permitted to access the internal dashboard.";

export const SSO_CALLBACK_URL = `${window.location.origin}/sso-callback`;

export const isInternalEmail = (email?: string | null): boolean => {
  const lower = email?.toLowerCase().trim();
  return !!lower && INTERNAL_EMAIL_SUFFIXES.some((suffix) => lower.endsWith(suffix));
};

// Persists a finished SSO login (the session itself is the HttpOnly cookie).
// Returns false, storing nothing, for non-internal accounts.
export function completeSsoLogin(data: { email?: string; refresh_token?: string }): boolean {
  if (!isInternalEmail(data.email)) return false;
  if (data.refresh_token) localStorage.setItem("refreshToken", data.refresh_token);
  if (data.email) localStorage.setItem("userEmail", data.email);
  setSsoSession();
  return true;
}
